import React from 'react'
import { Link, usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import Layout from '../../../../Shared/Layout/LayoutAdmin'
import Breadcrumbs from '../../../../Shared/Components/Breadcrumbs'
import { SIA_NAVY } from '../../../../constants/siaTheme'

const statusLabel = (attempt) => {
    if (attempt.status === 'in_progress') return 'En curso'
    if (attempt.abandoned) return 'Incompleto · 0'
    if (attempt.passed) return 'Aprobado'
    return 'No aprobado'
}

const UserResults = ({ person, attempts }) => {
    const { flash } = usePage().props

    return (
        <>
            <div className="mb-5 mt-5">
                <Breadcrumbs currentPath={`/admin/sia/manage/examenes/resultados/${person.id}`} />
            </div>
            <div className="d-flex justify-content-between align-items-start gap-3 mb-6">
                <div>
                    <h1 className="fs-2 fw-bold mb-1">{person.name}</h1>
                    <div className="text-gray-600">{person.email}</div>
                </div>
                <Link href={route('sia.manage.exams.results')} className="btn btn-sm btn-light">Volver</Link>
            </div>
            {flash?.success && <div className="alert alert-success">{flash.success}</div>}
            {flash?.error && <div className="alert alert-danger">{flash.error}</div>}
            {attempts.length === 0 && <p className="text-muted">Este usuario no tiene intentos.</p>}
            <div className="d-flex flex-column gap-5 mb-10">
                {attempts.map((attempt) => (
                    <div key={attempt.id} className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-start gap-3 mb-4">
                                <div>
                                    <div className="text-gray-500 fs-7 text-uppercase">{attempt.section}</div>
                                    <div className="fw-bold fs-4" style={{ color: SIA_NAVY }}>{attempt.title}</div>
                                    <div className="text-gray-600">{statusLabel(attempt)} · {attempt.finished_at || 'Sin fecha'}</div>
                                </div>
                                <div className="text-end">
                                    <div className="fw-bold fs-1" style={{ color: SIA_NAVY }}>{attempt.score ?? '—'}</div>
                                    <div className="text-gray-600">{attempt.correct_count} de {attempt.question_count}</div>
                                    {attempt.can_unlock && (
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary mt-3"
                                            onClick={() => Inertia.post(route('sia.manage.exams.unlock', attempt.id))}
                                        >
                                            Habilitar de nuevo
                                        </button>
                                    )}
                                    {attempt.retry_allowed && <div className="text-success mt-2">Habilitado para repetir</div>}
                                </div>
                            </div>
                            {attempt.answers.map((answer, index) => (
                                <div key={index} className="border-top py-3">
                                    <div className="fw-semibold mb-1">{index + 1}. {answer.prompt}</div>
                                    <div>Respondió: {answer.unanswered ? 'Sin respuesta' : (answer.selected || '—')}</div>
                                    <div className="text-gray-600">Correcta: {answer.correct || '—'}</div>
                                    <div style={{ color: answer.is_correct ? '#0f7a3a' : '#9b2c2c' }}>
                                        {answer.unanswered ? 'Fallida · sin respuesta' : answer.is_correct ? 'Acertó' : 'No acertó'}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

UserResults.layout = (page) => <Layout title="Detalle de exámenes">{page}</Layout>

export default UserResults
